import { Check, X } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const ROWS = [
    {
        area: "Strategy",
        trad: "Treats AI rollout and team alignment as separate initiatives.",
        method: "Integrates process engineering and behavioral alignment simultaneously.",
    },
    {
        area: "Exceptions",
        trad: "Leaves employees to guess how to handle automated exceptions.",
        method: "Engineers seamless exception-handling protocols directly in-app.",
    },
    {
        area: "Measurement",
        trad: "Focuses primarily on software integration.",
        method: "Uses business analysis to tie human-in-the-loop performance directly to hard KPIs.",
    },
];

export default function Advantage() {
    return (
        <section id="advantage" className="relative py-24 sm:py-28">
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <SectionHead
                    index="04"
                    label="The Comparison"
                    title={
                        <>
                            The HITL.partners <span className="text-blaze">Advantage</span>
                        </>
                    }
                />

                <Reveal delay={0.1}>
                    <div
                        data-testid="advantage-comparison-table"
                        className="mt-14 border border-line bg-panel/40"
                    >
                        {/* header */}
                        <div className="hidden grid-cols-[0.9fr_1fr_1fr] border-b border-line md:grid">
                            <div className="flex items-center p-6 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                                Workflow Area
                            </div>
                            <div className="flex items-center gap-3 border-l border-line p-6">
                                <X className="h-4 w-4 shrink-0 text-slate-500" strokeWidth={2.5} />
                                <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">
                                    Traditional Tech Implementation
                                </span>
                            </div>
                            <div className="flex items-center gap-3 border-l border-blaze/30 bg-blaze/[0.06] p-6">
                                <Check className="h-4 w-4 shrink-0 text-blaze" strokeWidth={2.5} />
                                <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-white">
                                    The HITL.partners Methodology
                                </span>
                            </div>
                        </div>

                        {ROWS.map((r, i) => (
                            <div
                                key={r.area}
                                className={`grid border-b border-line last:border-b-0 md:grid-cols-[0.9fr_1fr_1fr] ${
                                    i === 0 ? "" : "border-t md:border-t-0"
                                }`}
                            >
                                <div className="flex items-center gap-3 p-6 md:border-b-0">
                                    <span className="font-mono text-[10px] tracking-[0.2em] text-blaze md:hidden">0{i + 1}</span>
                                    <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
                                        {r.area}
                                    </span>
                                </div>
                                <div className="flex items-start gap-3 border-t border-line p-6 text-sm leading-relaxed text-slate-500 md:border-l md:border-t-0">
                                    <X className="mt-0.5 h-4 w-4 shrink-0 text-slate-600" strokeWidth={2.5} />
                                    <span>{r.trad}</span>
                                </div>
                                <div className="flex items-start gap-3 border-t border-line bg-blaze/[0.05] p-6 text-sm font-medium leading-relaxed text-slate-100 md:border-l md:border-blaze/30 md:border-t-0">
                                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-blaze" strokeWidth={2.5} />
                                    <span>{r.method}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
